module.exports = __webpack_public_path__ + "img/award_img04.6b8b1097.jpg";